import { render, staticRenderFns } from "./TourMetaDetails.vue?vue&type=template&id=5c9fd088&scoped=true&"
import script from "./TourMetaDetails.vue?vue&type=script&lang=js&"
export * from "./TourMetaDetails.vue?vue&type=script&lang=js&"
import style0 from "./TourMetaDetails.vue?vue&type=style&index=0&id=5c9fd088&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c9fd088",
  null
  
)

export default component.exports